// src/Footer.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, getWhatsappLink } from './config';

// Generamos el link usando la configuración centralizada para el botón principal
export const whatsappLink = getWhatsappLink("¡Hola! Estoy interesado en los modelos de carros Bestune y me gustaría recibir más información de un asesor de ventas.");

const emailSubject = encodeURIComponent("Consulta desde el pie de página de Bestune Cars");
const emailBody = encodeURIComponent("Estimados Bestune Cars,\n\nEscribo para consultar sobre...");
const mailtoLink = `mailto:${COMPANY_INFO.email}?subject=${emailSubject}&body=${emailBody}`;

export const IconoWhatsappPNG: React.FC = () => (
    <img src="/WhatsappLogo.webp" alt="WhatsApp Logo" className="w-6 h-6" />
);

const IconoEmailPNG: React.FC = () => (
    <img src="/CorreoLogo.webp" alt="Email Logo" className="w-6 h-6" />
);

const Footer: React.FC = () => {
    return (
        <footer className="bg-black/95 text-white pt-10 pb-6 shadow-inner border-t border-gray-900"> 
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 pb-8">
                    
                    {/* Columna 1: Info Empresa */}
                    <div className="md:col-span-2 text-center md:text-left">
                        <span className="text-3xl font-extrabold tracking-widest text-white">
                            BESTUNE CARS
                        </span>
                        <p className="mt-4 text-gray-400 max-w-md mx-auto md:mx-0 text-sm">
                            Tu mejor opción en vehículos multi-marca de alta calidad. Experimenta el lujo, la tecnología y el rendimiento superior en cada viaje.
                        </p>
                    </div>

                    {/* Columna 2: Enlaces */}
                    <div className="text-center md:text-left">
                        <h3 className="text-lg font-bold text-yellow-500 mb-4">Explora</h3>
                        <ul className="space-y-2">
                            <li><Link to="/" className="text-gray-400 hover:text-white transition duration-150 text-sm">Inicio</Link></li>
                            <li><Link to="/catalogo" className="text-gray-400 hover:text-white transition duration-150 text-sm">Catálogo de Vehículos</Link></li>
                            <li><Link to="/nosotros" className="text-gray-400 hover:text-white transition duration-150 text-sm">Acerca de Nosotros</Link></li>
                            <li><Link to="/concesionarios" className="text-gray-400 hover:text-white transition duration-150 text-sm">Nuestros Concesionarios</Link></li>
                        </ul>
                    </div>

                    {/* Columna 3: Contacto */}
                    <div className="text-center md:text-right">
                        <h3 className="text-lg font-bold text-yellow-500 mb-4">Contáctanos</h3>
                        <div className="space-y-3">
                            <a 
                                href={whatsappLink} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center md:justify-end space-x-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 py-2 px-4 rounded-full transition duration-150 shadow-md"
                            >
                                <IconoWhatsappPNG />
                                <span>Asesor de Ventas</span>
                            </a>
                            
                            <a 
                                href={mailtoLink} 
                                className="text-gray-300 hover:text-yellow-500 transition duration-150 flex items-center justify-center md:justify-end space-x-2"
                            >
                                <IconoEmailPNG />
                                <span className="text-sm font-medium">Contáctanos por Correo</span>
                            </a>
                        </div>
                    </div>
                </div>
                
                {/* --- SECCIÓN INFERIOR COMPACTA --- */}
                <div className="pt-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 gap-4">
                    
                    {/* Izquierda: Copyright */}
                    <div className="text-center md:text-left">
                        © {new Date().getFullYear()} Bestune Cars. Todos los derechos reservados.
                    </div>

                    {/* Derecha: Legales + Desarrolladores */}
                <div className="flex flex-wrap justify-center gap-4 items-center">
                    {/* CAMBIO: Usamos button en lugar de a href="#" para evitar la advertencia */}
                    <button className="hover:text-yellow-500 transition cursor-pointer">Aviso Legal</button>
                    <span className="text-gray-700 hidden sm:inline">•</span>
                    <button className="hover:text-yellow-500 transition cursor-pointer">Política de Privacidad</button>
                    
                    {/* Separador vertical */}
                    <span className="text-gray-700 border-l border-gray-700 pl-4 ml-2 h-3 block"></span>
                        
                        {/* DESARROLLADORES (Separados) */}
                        <div className="flex items-center gap-1">
                            <span className="uppercase tracking-wider text-[10px] opacity-70 mr-1">Desarrollado por</span>
                            
                            {/* Alex Ver. */}
                            <a 
                                href="https://wa.me/584242519130" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="font-bold text-gray-400 hover:text-yellow-500 transition"
                                title="Contactar a Alex Ver."
                            >
                                Alex Ver.
                            </a>

                            <span className="text-gray-600">&</span>

                            {/* Luis Fer. */}
                            <a 
                                href="https://wa.me/584242026767" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="font-bold text-gray-400 hover:text-yellow-500 transition"
                                title="Contactar a Luis Fer."
                            >
                                Luis Fer.
                            </a>
                        </div>
                    </div>

                </div>

            </div>
        </footer>
    );
};

export default Footer;